import { Placement } from './common'
import { normalizeSportCode } from './sports'

export type SportUrlData = {
    sportCode: string
    url: string
}

export const sportUrls7News: SportUrlData[] = [
    {
        sportCode: 'ATH',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-athletics?utm_source=7NEWS&utm_medium=athletics-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'ATH0201',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-athletics?utm_source=7NEWS&utm_medium=athletics-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'BDM',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-badminton?utm_source=7NEWS&utm_medium=badminton-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'BK3',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-basketball-3x3?utm_source=7NEWS&utm_medium=3x3-basketball-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'VBV',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-beach-volleyball?utm_source=7NEWS&utm_medium=beach-volleyball-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'BOX',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-boxing?utm_source=7NEWS&utm_medium=boxing-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'CKT',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-t20-cricket?utm_source=7NEWS&utm_medium=cricket-event&utm_campaign=comm-games-schedule',
    },
    {
        sportCode: 'MTB',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-mountain-bike?utm_source=7NEWS&utm_medium=mountain-bike-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'CRD1002',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-road?utm_source=7NEWS&utm_medium=road-cycling-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'CRD0701',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-track?utm_source=7NEWS&utm_medium=track-cycling-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'CTR',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-track?utm_source=7NEWS&utm_medium=track-cycling-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'DIV',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-diving?utm_source=7NEWS&utm_medium=diving-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'GAR',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-gymnastic-artistic?utm_source=7NEWS&utm_medium=art-gymnastic-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'GRY',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-gymnastic-rhythmic?utm_source=7NEWS&utm_medium=rhythm-gymnastic-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'HOC',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-hockey?utm_source=7NEWS&utm_medium=hockey-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'JUD',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-judo?utm_source=7NEWS&utm_medium=judo-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'LBO',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-lawn-bowls?utm_source=7NEWS&utm_medium=lawn-bowls-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'NBL',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-netball?utm_source=7NEWS&utm_medium=netball-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'RUG',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-rugby-sevens?utm_source=7NEWS&utm_medium=rugby-sevens-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'SQU',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-squash?utm_source=7NEWS&utm_medium=squash-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'TTE',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-table-tennis?utm_source=7NEWS&utm_medium=table-tennis-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'TRI',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-triathlon?utm_source=7NEWS&utm_medium=triathlon-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'WLF',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-weightlifting?utm_source=7NEWS&utm_medium=weightlifting-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'PWL',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-para-powerlifting?utm_source=7NEWS&utm_medium=para-powerlifting-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'WRE',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-weightlifting?utm_source=7NEWS&utm_medium=weightlifting-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'SWM',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-swimming?utm_source=7NEWS&utm_medium=swimming-event&utm_campaign=schedule-widget',
    },
    {
        sportCode: 'CER',
        url: 'https://7plus.com.au/commonwealth-games?utm_source=7NEWS&utm_medium=opening-closing-ceremony&utm_campaign=schedule-widget',
    },
]

export const sportUrls7Plus: SportUrlData[] = [
    {
        sportCode: 'ATH',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-athletics',
    },
    {
        sportCode: 'ATH0201',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-athletics',
    },
    {
        sportCode: 'BDM',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-badminton',
    },
    {
        sportCode: 'BK3',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-basketball-3x3',
    },
    {
        sportCode: 'VBV',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-beach-volleyball',
    },
    {
        sportCode: 'BOX',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-boxing',
    },
    {
        sportCode: 'CKT',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-t20-cricket',
    },
    {
        sportCode: 'MTB',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-mountain-bike',
    },
    {
        sportCode: 'CRD1002',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-road',
    },
    {
        sportCode: 'CRD0701',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-track',
    },
    {
        sportCode: 'CTR',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-cycling-track',
    },
    {
        sportCode: 'DIV',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-diving',
    },
    {
        sportCode: 'GAR',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-gymnastic-artistic',
    },
    {
        sportCode: 'GRY',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-gymnastic-rhythmic',
    },
    {
        sportCode: 'HOC',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-hockey',
    },
    {
        sportCode: 'JUD',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-judo',
    },
    {
        sportCode: 'LBO',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-lawn-bowls',
    },
    {
        sportCode: 'NBL',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-netball',
    },
    {
        sportCode: 'RUG',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-rugby-sevens',
    },
    {
        sportCode: 'SQU',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-squash',
    },
    {
        sportCode: 'TTE',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-table-tennis',
    },
    {
        sportCode: 'TRI',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-triathlon',
    },
    {
        sportCode: 'WLF',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-weightlifting',
    },
    {
        sportCode: 'PWL',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-para-powerlifting',
    },
    {
        sportCode: 'WRE',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-weightlifting',
    },
    {
        sportCode: 'SWM',
        url: 'https://7plus.com.au/commonwealth-games-birmingham-swimming',
    },
    {
        sportCode: 'CER',
        url: 'https://7plus.com.au/commonwealth-games',
    },
]

export const getLinkUrlFromSport = (sportCode: string, placement: Placement = '7news') => {
    const normalizedSportCode = normalizeSportCode(sportCode)

    if (placement === '7news') {
        const sportData = sportUrls7News.find((el) => el.sportCode === normalizedSportCode)
        if (sportData) {
            return sportData.url
        } else {
            return 'https://7plus.com.au/?utm_source=7NEWS&utm_medium=unknown-event&utm_campaign=schedule-widget'
        }
    } else {
        const sportData = sportUrls7Plus.find((el) => el.sportCode === normalizedSportCode)
        if (sportData) {
            return sportData.url
        } else {
            return 'https://7plus.com.au/'
        }
    }
}
